import type { BadgeProps } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import React from 'react';

const STATUS_COLOR_MAP: Record<string, string> = {
  enrolled: 'green',
  contacted: 'blue',
  'not contacted': 'orange',
  inactive: 'gray',
  unknown: 'gray',
};

interface CreatorStatusBadgeProps extends BadgeProps {
  statusText: string;
  status?: string;
}

export const CreatorStatusBadge: React.FC<CreatorStatusBadgeProps> = ({
  statusText,
  status,
  colorPalette,
  ...rest
}) => {
  const resolvedColorPalette =
    colorPalette ?? (status ? (STATUS_COLOR_MAP[status] ?? 'gray') : 'green');

  return (
    <Badge colorPalette={resolvedColorPalette} {...rest}>
      {statusText.replace(/(^\w|\s\w)/g, (char) => char.toUpperCase())}
    </Badge>
  );
};

export default CreatorStatusBadge;
